import React from 'react';
import { ApiKeyManagement } from '../../../pages/ApiKeyManagement';
import { FeatureReadOnlyBanner } from '../components/FeatureReadOnlyBanner';

export const ApiKeysRoute: React.FC = () => (
  <>
    <FeatureReadOnlyBanner feature="api_access" />
    <ApiKeyManagement />
  </>
);
